//appreset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const ApPreset = definePreset(Aura, {

  semantic: {
    primary: {
      '50': 'var(--color-brand-50)',
      '100': 'var(--color-brand-100)',
      '200': 'var(--color-brand-200)',
      '300': 'var(--color-brand-300)',
      '400': 'var(--color-brand-400)',
      '500': 'var(--color-brand-500)',
      '600': 'var(--color-brand-600)',
      '700': 'var(--color-brand-700)',
      '800': 'var(--color-brand-800)',
      '900': 'var(--color-brand-900)',
      '950': 'var(--color-brand-950)',
    },
  },
});

export default ApPreset;
